import { render, staticRenderFns } from "./AlertBlock.vue?vue&type=template&id=438822e0&"
import script from "./AlertBlock.vue?vue&type=script&lang=ts&setup=true&"
export * from "./AlertBlock.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./AlertBlock.vue?vue&type=style&index=0&id=438822e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports